import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

const SmallSlidePanel = ({
  isOpen,
  onClose,
  children,
  width = 500,
  showCloseButton = true,
}) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Backdrop */}
          <motion.div
            className="fixed inset-0 bg-black/10 backdrop-blur-[1px] bg-white/10 z-[9998]"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
          />

          {/* Sliding Panel */}
          <motion.div
            className="fixed right-[0.5%] top-[30%] -translate-y-1/2 bg-white shadow-2xl rounded-xl z-[9999]"
            style={{ width }}
            initial={{ x: "120%" }}
            animate={{ x: 0 }}
            exit={{ x: "120%" }}
            transition={{
              type: "spring",
              stiffness: 120,
              damping: 22,
            }}
          >
            {/* Close Button */}
            {showCloseButton && (
              <div
                onClick={onClose}
                className="absolute top-0 right-0 h-[40px] w-[40px] bg-[#FF0000] rounded-tr-[10px] rounded-bl-[20px] flex items-center justify-center cursor-pointer z-10"
              >
                <X color="#fff" />
              </div>
            )}
            {children}
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default SmallSlidePanel;
